import React, { Component } from "react";
import Select from "react-select";

import Popup from "react-popup";

const tipoPresentacion = {
  select: "SELECT",
  tabla: "TABLA"
};

export default class PrestamoCU extends Component {
  constructor(props) {
    super(props);
   
    
    this.state = {
      selectedOption: this.props.itemSelected,
      opcion: []
    };
  }

  inicializarEstados () {
    this.setState({
      selectedOption: undefined,
      
  });
  
 
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {

  }

 

  handleChangeSelector = (selectedOption) => {
  //  console.log("valor seleccionado "+selectedOption)
    if (selectedOption == null)
      this.props.selectorValue(undefined);
    else
      this.props.selectorValue(selectedOption.value);
  };

  obtenerTipoPrestamo() {
    switch (this.props.presentacion) {
      case tipoPresentacion.select:

    
    
        return (
          <div className="form-group" id="prestamo">
            <label className="input-label-bold">{this.props.titulo} *</label>
            <div className="is-invalid" id="prueba">
            <Select className="group-tipo" id="tipo" name="tipo"
              defaultValue={this.props.itemSelected}
              onChange={this.handleChangeSelector}
              placeholder="-- seleccione --"
              options={this.props.prestamos}
              isClearable

              isSearchable

              noOptionsMessage={() => 'SIN DATOS'}
            />
           </div>
          </div>
        );
      case tipoPresentacion.tabla:
        break;
    }
  }

  render() {
    const { selectedOption } = this.state;
    return (
      <div>
        <div className="form-group">
          {this.obtenerTipoPrestamo()}
        </div>
      </div>
    );
  }
}
